/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetContentListResponse } from '../../models/get-content-list-response';

export interface GetSectionContentList$Params {

/**
 * ID sekcie
 */
  id: number;
}

export function getSectionContentList(http: HttpClient, rootUrl: string, params: GetSectionContentList$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContentListResponse>> {
  const rb = new RequestBuilder(rootUrl, getSectionContentList.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetContentListResponse>;
    })
  );
}

getSectionContentList.PATH = '/admin/menu/{id}/contentList';
